import { defineStore } from "pinia"
import { computed, ref } from "vue"

export const useAuth = defineStore("auth", () => {
    const authUser = ref(null)
    const legalConformation = ref(false)
    
    const access_token = computed(() => authUser.value?.access_token ?? "")
    const isLoggedIn = computed(() => !!authUser.value)
    const family_name = computed(() => authUser.value?.profile.family_name ?? "")
    const given_name = computed(() => authUser.value?.profile.given_name ?? "")
    const name = computed(() => `${given_name.value} ${family_name.value}`)

    const setUpUserCredentials = (user) => {
        authUser.value = user
    }

    const clearUserData = () => {
        authUser.value = null
    }

    return {
        access_token,
        isLoggedIn,
        family_name,
        given_name,
        name,
        legalConformation,
        setUpUserCredentials,
        clearUserData
    }
})